/*
 * � 2020 Microsoft. All rights reserved.
 */

define('MenuUI/CustomButton',['pixi', 'absolute', 'lodash'],

    function (PIXI, Absolute, _) {

        var CustomButton = function (options) {
            this.initialize(options);
        };

        CustomButton.constructor = CustomButton;
        CustomButton.prototype = Object.create(PIXI.Sprite.prototype);

        CustomButton.prototype.initialize = function (options) {

            this.options = options;

            this.container = new PIXI.DisplayObjectContainer();

            // create up state
            this.upTexture = PIXI.Texture.fromFrame(this.options.up);
            this.overTexture = PIXI.Texture.fromFrame(this.options.over);
            this.downTexture = PIXI.Texture.fromFrame(this.options.down);

            PIXI.Sprite.call(this, this.upTexture);

            this.interactive = true;
            this.buttonMode = true;
            this._hasFocus = false;

            this.focusIndicator = new PIXI.Graphics();
            this.focusIndicator.lineStyle(1, 0xFFFFFF);
            var margin = Absolute.Coords.x(2);
            this.focusIndicator.drawRect(margin, margin, this.width - 2 * margin, this.height - 2 * margin);


            if (Absolute.Platform.supportsTouch()) {

                this.touchstart = function (evt) {
                    this.setTexture(this.downTexture);
                    this.options.action.down();
                };

                this.touchend = function (evt) {
                    this.setTexture(this.upTexture);
                    this.options.action.up();
                    this.handleAction();
                };

                this.touchendoutside = function (evt) {
                    this.setTexture(this.upTexture);
                    this.options.action.up();
                };

                // Support mouse on laptops/desktops that have touch displays
                if (Absolute.Platform._isWindows() || (Absolute.Platform._isMac() && !Absolute.Platform._isIOS())) {
                    this.bindMouseEvents();
                }

            } else {
                this.bindMouseEvents();
            }
        };

        CustomButton.prototype.bindMouseEvents = function () {

            this.mouseover = function (evt) {
                this.setTexture(this.overTexture);
            };
            this.mouseout = function (evt) {
                this.setTexture(this.upTexture);
                this.options.action.up();
            };

            this.mousedown = function (evt) {
                this.setTexture(this.downTexture);
                this.options.action.down();
            }.bind(this);

            this.mouseup = function (evt) {
                this.setTexture(this.upTexture);
                this.options.action.up();
                this.handleAction();
            }.bind(this);
        };

        CustomButton.prototype.handleAction = function () {
            Absolute.AudioManager.playSound('button');
        };

        return CustomButton;

    });

